import lodashGet from 'lodash/get';

/**
 * Immutably sorts an array of objects alphabetically
 * @param arr - array of objects to sort
 * @param path - path to sort by
 */
export const sortAlphabeticallyByPath = <T extends Array<Record<string, any>>>(
  arr: T,
  path: string,
): T => {
  const sortedArray = [...arr] as T;

  return sortedArray.sort((a, b) => {
    const valueA = lodashGet(a, path, '').toUpperCase();
    const valueB = lodashGet(b, path, '').toUpperCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }

    return 0;
  });
};
